module.exports = __webpack_public_path__ + "img/user.1f593bd6.svg";